export const optionMeetingPoint = [
  { name: "Block", value: 6 },
  { name: "Counter", value: 3 },
  { name: "Court", value: 4 },
  { name: "Place", value: 1 },
  { name: "Room", value: 2 },
  { name: "Section", value: 5 },
  { name: "Table", value: 7 },
];
